import styled from 'styled-components';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
var InputGroup = styled(Box)({
  position: "relative",
  display: "flex",
  width: "100%"
});
export { InputGroup };